import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../common/mixins';
import { Text } from '../../common';
import { selectNormalizedCurrentTime, selectNormalizedInterval } from '../../../selectors';

const containerRules = ({ theme, mini }) => ({
  color: 'white',
  display: 'flex',
  position: 'absolute',
  zIndex: 1,
  right: `calc(${theme.margin.xxlarge} + ${theme.margin.small})`,
  top: theme.margin.xxlarge,
  padding: theme.margin.fine,
  backgroundColor: theme.color.adInfoBgColor,
  borderLeft: `solid 4px ${theme.color.ads}`,
  extend: [
    largeScreen({
      right: `calc(${theme.margin.large} + ${theme.margin.small})`,
      top: theme.margin.large,
    }),
    smallScreen({
      right: `calc(${theme.margin.medium} + ${theme.margin.small})`,
      top: theme.margin.medium,
    }),
    {
      condition: mini,
      style: {
        right: theme.margin.xlarge,
        top: theme.margin.fine,
      },
    },
  ],
});

function AdInfo({ mini }) {
  const { css } = useFela({ mini });

  const {
    adsCount,
    adsLeft,
  } = useSelector(({ playback }) => ({
    adsCount: playback.adsCount,
    adsLeft: playback.adsLeft,
  }), shallowEqual);
  const [,, duration] = useSelector(selectNormalizedInterval, shallowEqual);
  const currentTime = useSelector(selectNormalizedCurrentTime);

  const ads = adsCount - adsLeft;
  const timeLeft = Math.max(Math.floor(duration - currentTime), 0);

  return (
    <div className={css(containerRules)}>
      <Text id="adInfo" bold values={{ ads, adsCount }} />
      <Text bold>&nbsp;&bull;&nbsp;{timeLeft}</Text>
    </div>
  );
}

AdInfo.propTypes = {
  mini: PropTypes.bool,
};

export default React.memo(AdInfo);
